import { render, staticRenderFns } from "./SendYearlyOtchet.vue?vue&type=template&id=247be408"
import script from "./SendYearlyOtchet.vue?vue&type=script&lang=js"
export * from "./SendYearlyOtchet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports